import apiClient from "./apiClient";

export const fetchCoupons = async (params = {}) => {
  try {
    const { search = "", page = 1, limit = 10 } = params;
    const response = await apiClient.get(`/billing/coupons?search=${search}&page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchCouponUsers = async (params = {}) => {
  try {
    const { search = "", page = 1, limit = 10, couponId } = params;
    const response = await apiClient.get(`/billing/coupon-usage?search=${search}&page=${page}&limit=${limit}&couponId=${couponId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};